import { useState } from 'react';

import { addGuestLike, removeGuestLike } from '../helpers';
import { type GuestLikeProductInput } from '../types';

import { useShowGuestLikesToast } from './useGuestLikesToast';
import { useIsGuestLiked } from './useIsGuestLiked';

export function useGuestLikes(productId: number) {
  const isLiked = useIsGuestLiked(productId);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const sendGuestLikesToast = useShowGuestLikesToast();

  function toggleGuestLike(product: GuestLikeProductInput) {
    if (isLiked) {
      removeGuestLike(productId);
      return 'removed';
    }
    const result = addGuestLike({ ...product, timestamp: Date.now() });
    if (result === 'lastLike') {
      sendGuestLikesToast();
    }
    if (result === 'reachedCap') {
      setIsModalOpen(true);
    }
    return result;
  }

  return { isLiked, toggleGuestLike, isModalOpen, setIsModalOpen };
}
